/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(() => {
  // Close the mobile menu drawer when a same-page anchor link is tapped,
  // then scroll to the target after the drawer close animation.
  const DRAWER_CLOSE_DURATION = 450;

  document.addEventListener('click', (event) => {
    const link = event.target.closest('mobile-menu a[href]');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href) return;

    let hash = '';
    if (href.charAt(0) === '#') {
      hash = href;
    } else {
      try {
        const url = new URL(href, window.location.href);
        if (url.pathname === window.location.pathname && url.hash) {
          hash = url.hash;
        }
      } catch (error) {
        return;
      }
    }

    if (!hash || hash === '#') return;

    const target = document.querySelector(hash);
    if (!target) return;

    event.preventDefault();

    const drawer = link.closest('header-drawer');
    if (drawer) {
      drawer.dispatchEvent(new CustomEvent('theme:drawer:close', { bubbles: true }));
    }

    window.setTimeout(() => {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.history?.pushState?.(null, '', hash);
    }, DRAWER_CLOSE_DURATION);
  });
})();

(() => {
  // Touch taps pin the swatch tooltip open with no mouseleave to close it.
  if (!window.matchMedia('(hover: none)').matches) return;

  const SWATCH_TOOLTIP_SELECTOR = 'tooltip-component.swatch__button';
  const STOP_MOUSEENTER_ATTRIBUTE = 'data-tooltip-stop-mouseenter';

  // Beats mouseenter, so taps never open the tooltip - late-rendered swatches included.
  document.addEventListener(
    'mouseover',
    (event) => {
      event.target.closest?.(SWATCH_TOOLTIP_SELECTOR)?.setAttribute(STOP_MOUSEENTER_ATTRIBUTE, '');
    },
    { capture: true, passive: true }
  );
})();
